import React from "react";
import MyRatings from "./MyRatings";

export default function RatingsPage() {
    return (
        <div className="animate-fade-in">
            <MyRatings />
        </div>
    );
}
